import { Button } from "@/components/ui/button";
import { PageContainer } from "@/components/layout/PageContainer";

const ProviderAssessment = () => {
  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Comprehensive Assessment Tools
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Our advanced cognitive assessment platform combines AI technology with clinical expertise to provide accurate, detailed evaluations for your patients.
        </p>
        <div className="grid gap-8 md:grid-cols-2">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Key Features</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• AI-powered cognitive assessments</li>
              <li>• Real-time monitoring and analysis</li>
              <li>• Detailed patient progress tracking</li>
              <li>• HIPAA-compliant data security</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Benefits</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• Early detection of cognitive changes</li>
              <li>• Personalized treatment planning</li>
              <li>• Improved patient outcomes</li>
              <li>• Streamlined clinical workflow</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center">
          <Button size="lg" className="bg-primary hover:bg-primary/90">
            Request Demo
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default ProviderAssessment;